import firebase from 'src/utils/firebase';

export const handleSignInWithEmailAndPassword = async (email, password) =>{
    try {
        const res = await firebase.auth().signInWithEmailAndPassword(email, password);
        return res;
    } catch (error) {
        if (error.code === 'auth/invalid-credential') return 'auth/invalid-credential';
        return null;
    }
}
